import React from 'react';
import {
  BrowserRouter,
  Link,
  Navigate,
  Route,
  RouteObject,
  Routes,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import { AppLayout, Confirmation, Page } from 'components';
import Alert from 'containers/Alert';
import Header from 'containers/Header';
import Main from 'containers/Main';
import * as routesModule from 'pages/routes';
import { flattenRoutes, generateLinks } from 'utils';
import { getIsLoggedIn } from 'rdx/auth';

import LoginApp from '../LoginApp';

// @ts-ignore
// eslint-disable-next-line react/function-component-definition
export const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isLoggedIn = useSelector(getIsLoggedIn);

  if (!isLoggedIn) {
    // eslint-disable-next-line react/jsx-filename-extension
    return <Navigate to="/login" />;
  }

  return children;
};

function AllRoutes() {
  const routeValues = Object.values(routesModule);
  const routes: RouteObject[] = flattenRoutes(routeValues, 'subRoutes');
  const options: { link: string; title: string }[] = generateLinks(routeValues);

  return (
    <Routes>
      <Route path="/login" element={<LoginApp />} />
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <PrivateRoute>
              <Page {...route} />
            </PrivateRoute>
          }
        />
      ))}
      <Route
        path="*"
        element={
          <Page
            title="Onboarding Wizard"
            description="Setup and configure various aspects of Erply onboarding."
            rootPath={{ name: 'Onboarding Wizard' }}
            // eslint-disable-next-line react/no-unstable-nested-components
            component={() => (
              <div className="flex-fill d-flex flex-column">
                <div className="jumbotron">
                  <p>Onboarding Wizard</p>
                  <ol>
                    {options.map((option) => (
                      <li key={option.link}>
                        <Link to={option.link}>{option.title}</Link>
                      </li>
                    ))}
                  </ol>
                </div>
              </div>
            )}
          />
        }
      />
    </Routes>
  );
}

function RootRouter() {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const routeValues = Object.values(routesModule);
  const options: { link: string; title: string }[] = generateLinks(routeValues);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Alert />
      <Confirmation />
      <AppLayout
        header={<Header isLoggedIn={isLoggedIn} />}
        main={<Main links={options} main={<AllRoutes />} />}
      />
    </BrowserRouter>
  );
}

export default RootRouter;
